// extracted by mini-css-extract-plugin
export default {"container":"styles_container__OVYh4","circle":"styles_circle__xsWFb","bounce":"styles_bounce__xdwaj"};